import { useSetRecoilState } from "recoil";
import { taskCounterTemplateSearchAtom } from "../miscellaneous/taskCounterTemplateSearchAtom";

export const useSetTaskCounterTemplateSearch = () => {
  return useSetRecoilState(taskCounterTemplateSearchAtom);
};
